registerGlobal('TextUtils');
/*
 * For comparison of the methods below
 * you may want to check https://jsfiddle.net/anton_klymenko/tew8ccoy/
 */

TextUtils.callbackQueue = [];

// If useLegacy is set after some error occurred during the processing of an image,
// for already added items in the callbackQueue img.onload() or img.onerror()
// will still be called, which call TextUtils.processCallbacks(),
// so any already added items in the callbackQueue will be processed anyway,
// although for all future items legacy version will be called directly
// without using callbackQueue at all
TextUtils.useLegacy = false;

TextUtils.processCallbacks = function() {
    // All ready callbacks are called in the order of creation
    // Because other platforms work that way
    // And code for our games (lua-side) relies on it
    while (TextUtils.callbackQueue.length > 0
           && TextUtils.callbackQueue[0].done) {
        TextUtils.callbackQueue[0].callback();
        TextUtils.callbackQueue.shift();
    }
}

TextUtils.renderText = function(arg, textPtr, fontNamePtr, fontColor, fontSize, maxWidth, singleLine, dotsAtEnd, grayscale, callback) {
    var text = UTF8ToString(textPtr);
    var fontName = UTF8ToString(fontNamePtr);

    if (TextUtils.useLegacy
        || !document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#Extensibility', '1.1')
        || typeof InstallTrigger !== 'undefined') { // detect Gecko, see https://jsfiddle.net/anton_klymenko/ea0dzbe7/10/
        // If a browser doesn't support foreignObject (currently only IE...), then fallback to the legacy method
        TextUtils.useLegacy = true;
        TextUtils.renderTextLegacy(arg, text, fontName, fontColor, fontSize, maxWidth, singleLine, dotsAtEnd, grayscale, callback);
        return;
    }

    var canvas = document.createElement('canvas');
    if (!canvas) { // see http://stackoverflow.com/questions/19465089/will-document-createelement-ever-fail
        throw "Couldn't create a canvas!";
    }
    var ctx = canvas.getContext('2d');

    if (maxWidth == 0) {
        singleLine = true;
    }

    ctx.font = fontSize + "px Arial";

    var textWidth = Math.min(maxWidth, ctx.measureText(text).width);
    canvas.width = Math.max(textWidth, 1);

    // String wraps around if maxWidth == canvas.width,
    // and singleLine is inconsistent in the project, so we can't rely on it.
    // Therefore a workaround of +1px was chosen:
    var maxTextWidth = canvas.width + 1;

    // see http://stackoverflow.com/questions/7918868/how-to-escape-xml-entities-in-javascript
    function escapeXml(unsafe) {
        return unsafe.replace(/[<>&'"]/g, function (c) {
            switch (c) {
                case '<': return '&lt;';
                case '>': return '&gt;';
                case '&': return '&amp;';
                case '\'': return '&apos;';
                case '"': return '&quot;';
            }
        });
    }

    // see https://web.archive.org/web/20120218142216/http://www.phpwact.org/php/i18n/charsets
    // see http://stackoverflow.com/questions/12229572/php-generated-xml-shows-invalid-char-value-27-message
    // surrogates (\uD800-\uDFFF) are kept to show emoji
    function prepareUTF8forXML(inputStr) {
        return inputStr.replace(/[^\x09\x0A\x0D\x20-\xFF\x85\xA0-\uFDCF\uFDE0-\uFFFD]/gm, '');
    }

    var textEncoded = escapeXml(prepareUTF8forXML(text));

    var styleText = 'width:' + maxTextWidth + 'px; max-width:' + maxTextWidth + 'px; word-wrap: break-word; text-overflow: clip;';
    if (singleLine) {
        styleText = 'width:' + maxTextWidth + 'px; max-width:' + maxTextWidth + 'px; overflow: hidden; text-overflow: clip;';
    }
    if (dotsAtEnd) {
        ctx.font = fontSize + "px Arial";
        var dotWidth = ctx.measureText('..').width;
        styleText = 'text-overflow: ellipsis; overflow: hidden; width: ' + Math.max(1, Math.min(maxTextWidth, maxWidth - dotWidth)) + 'px; max-width: ' + maxWidth + 'px; white-space: nowrap; padding-right:' + dotWidth + 'px;';
    }

    var textColor;
    if (grayscale) {
        textColor = 'white';
    }
    else {
        textColor = TextUtils.integerToColor(fontColor);
    }

    var data = '<svg xmlns="http://www.w3.org/2000/svg" width="' + maxTextWidth + '">' +
        '<foreignObject width="100%" height="100%">' +
        '<div xmlns="http://www.w3.org/1999/xhtml" id="svgEmbeddedText" style="font-size:' + fontSize + 'px; line-height:125%; font-family:Arial; color:' + textColor + ';' + styleText + '">' +
        textEncoded +
        '</div>' +
        '</foreignObject>' +
        '</svg>';

    // append svg to DOM, it is necessary for accessing text height through clientHeight
    var container = document.createElement('div');
    document.body.appendChild(container);
    container.innerHTML = data;

    var textHeight = document.getElementById("svgEmbeddedText").clientHeight;

    // remove svg from DOM
    var myNode = container;
    while (myNode.firstChild) {
        myNode.removeChild(myNode.firstChild);
    }
    container.parentElement.removeChild(container);

    data = data.replace('<svg ', '<svg height="' + Math.max(textHeight, 1) + '" ');
    canvas.height = Math.max(textHeight, 1);

    var DOMURL = window.URL || window.webkitURL || window;
    var img = new Image();

    // see http://stackoverflow.com/questions/27652694/inserting-html-into-canvas-without-creating-cors-restriction
    // see http://stackoverflow.com/questions/23223718/failed-to-execute-btoa-on-window-the-string-to-be-encoded-contains-characte
    var url = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(data)));

    var callbackWrapper = {
        done : false,
        callback : function() {
            try
            {
                if (grayscale) {
                    ctx.fillStyle = "#000000";
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                }
                else {
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                }
                ctx.drawImage(img, 0, 0);

                DOMURL.revokeObjectURL(url);

                var width = canvas.width;
                var height = canvas.height;
                var byteArray = ctx.getImageData(0, 0, width, height).data;
                var size = byteArray.length;

                var buffer = _malloc(size);
                HEAPU8.set(byteArray, buffer);
                if (callback) {
                    dynCall('viiiiii', callback, [arg, width, height, grayscale, buffer, size]);
                }
            }
            catch (error)
            {
                console.error("Text generation failed for: {" + url + "} with error " + error.message);
                TextUtils.useLegacy = true;
                TextUtils.renderTextLegacy(arg, text, fontName, fontColor, fontSize, maxWidth, singleLine, dotsAtEnd, grayscale, callback);
            }
        }
    };
    TextUtils.callbackQueue.push(callbackWrapper);

    img.onload = function() {
        callbackWrapper.done = true;
        TextUtils.processCallbacks();
    }

    img.onerror = function() {
        // This should never happen, but just in case --
        // do a fallback to legacy version.
        console.error("Text generation failed for: {" + url + "}");
        TextUtils.useLegacy = true;

        callbackWrapper.callback = function() {
            TextUtils.renderTextLegacy(arg, text, fontName, fontColor, fontSize, maxWidth, singleLine, dotsAtEnd, grayscale, callback);
        }
        callbackWrapper.done = true;
        TextUtils.processCallbacks();
    }

    img.crossOrigin = "Anonymous";
    img.src = url;
}

TextUtils.renderTextLegacy = function(arg, text, fontName, fontColor, fontSize, maxWidth, singleLine, dotsAtEnd, grayscale, callback) {
    var canvasID = grayscale ? 'hiddenCanvasGrayscale' : 'hiddenCanvas';
    var canvas = document.getElementById(canvasID);
    if (!canvas) {
        throw "Canvas with id " + canvasID + " doesn't exists!";
    }
    var ctx = canvas.getContext('2d');

    // see http://stackoverflow.com/questions/4991171/auto-line-wrapping-in-svg-text
    // for a list of svg alternatives,
    // note, that
    // 1. IE as of v.11 doesn't support foreignObject;
    // 2. textPath needs list of lines, but we don't know how many lines text will take;
    // 3. implementing wrap algorithm by generating svg on the fly without foreignObject is useless,
    // since there is canvasContext.drawLines method which is faster.
    function wrapText(context, text, x, y, maxWidth, lineHeight, dotsAtEnd) {
        y += lineHeight; // since textBaseline = "top" doesn't work - compensate for it
        var ellipsis = '\u2026';
        var ellipsisWidth = ctx.measureText(ellipsis).width;
        var lines = [];
        var textWidth = 0;
        var lineBegin = 0;
        var lineEnd = 0;
        var lineWidth = 0;
        var wordBegin = 0;
        var wordWidth = 0;
        var charPos = 0;
        while (true) {
            if (charPos >= text.length) {
                textWidth = Math.max(textWidth, lineWidth);
                var line = text.slice(lineBegin, text.length);
                lines.push({
                    text: line,
                    pos: [x, y]
                });
                y += lineHeight;
                break;
            }

            // One 'visible' character can correspond to the two or more characters in the utf-16 string,
            // as in case of emoji, where each emoji stored as a two unicode surrogates.
            var charCurrent = text.charAt(charPos);
            var charPosLeft = charPos;
            do {
                var charCode = text.charCodeAt(charPos); // charCodeAt returns NaN if index is out of range
                // see https://mathiasbynens.be/notes/javascript-unicode#iterating-over-symbols
                if (charCode >= 0xD800 && charCode <= 0xDBFF) {
                    charCode = text.charCodeAt(charPos + 1);
                    if (charCode >= 0xDC00 && charCode <= 0xDFFF) {
                        charPos++;
                    }
                }
                // variation selectors
                charCode = text.charCodeAt(charPos + 1);
                if (charCode >= 0xFE00 && charCode <= 0xFE0F) {
                    charPos++;
                }
                // emoji skin tone modifiers
                charCode = text.charCodeAt(charPos + 1);
                if (charCode == 0xD83C) {
                    charCode = text.charCodeAt(charPos + 2);
                    if (charCode >= 0xDFFB && charCode <= 0xDFFF) {
                        charPos += 2;
                    }
                }
                // zero width joiner
                charCode = text.charCodeAt(charPos + 1);
                if (charCode == 0x200D) {
                    charPos += 2;
                }
            } while (charCode == 0x200D); // repeat if 'zero width joiner' was found

            charPos = Math.min(charPos, text.length);
            charCurrent = text.slice(charPosLeft, charPos + 1);

            // see http://stackoverflow.com/questions/7549182/android-paint-measuretext-vs-gettextbounds
            // for comparison of the measureText() with getTextBounds() on Android (as an example)
            var charWidth = context.measureText(charCurrent).width;
            lineWidth += charWidth;
            wordWidth += charWidth;

            if (dotsAtEnd) {
                if (lineWidth > maxWidth - ellipsisWidth && lineEnd == 0) {
                    lineEnd = charPosLeft;
                }
                if (lineWidth > maxWidth) {
                    textWidth = maxWidth;
                    lines.push({
                        text: text.substr(0, lineEnd) + ellipsis,
                        pos: [x, y]
                    });
                    y += lineHeight;
                    break;
                }
            }
            else {
                if (charCurrent == ' ' || charCurrent == '/') {
                    lineEnd = charPos + 1;
                    wordBegin = charPos + 1;
                    wordWidth = 0;
                }

                if (lineWidth > maxWidth) {
                    var line; // printed below
                    textWidth = Math.max(textWidth, lineWidth - charWidth);

                    // If current line is empty,
                    // so this one word is already wider than maxwidth
                    if (lineBegin == lineEnd) {
                        if (charPos > wordBegin) {
                            // Print part of the word.
                            line = text.slice(wordBegin, charPosLeft);
                            wordBegin = charPosLeft;
                            wordWidth = charWidth;
                        }
                        else {
                            // If even one character wider than the maxwidth
                            // force to print it.
                            line = text.slice(wordBegin, wordBegin + 1);
                            wordBegin = wordBegin + 1;
                            wordWidth = 0;
                        }

                        lineBegin = wordBegin;
                        lineEnd = lineBegin;
                        lineWidth = wordWidth;
                    }
                    else {
                        // Print current line.
                        line = text.slice(lineBegin, lineEnd);
                        lineBegin = wordBegin;
                        lineEnd = lineBegin;
                        lineWidth = wordWidth;
                    }

                    lines.push({
                        text: line,
                        pos: [x, y]
                    });
                    y += lineHeight;
                }
            }
            charPos++;
        }

        y += lineHeight / 4; // Trying to estimate bounding box, since JS doesn't inform about text height.

        return {
            lines: lines,
            width: Math.min(maxWidth, textWidth),
            height: y - lineHeight
        };
    }

    function drawLines(ctx, data) {
        data.lines.map(function(line) {
            ctx.fillText(line.text, line.pos[0], line.pos[1]);
        });
    }

    function measureLine(ctx, text, maxWidth, lineHeight) {
        var width = ctx.measureText(text).width;
        if (maxWidth) {
            width = Math.min(maxWidth, width);
        }
        return {
            width: width,
            height: lineHeight + lineHeight / 4 // Trying to estimate bounding box, since JS doesn't inform about text height.
        };
    }

    function resizeCanvasToResult(result) {
        if (grayscale) {
            canvas.width = Math.max(result.width, 1);
            canvas.height = Math.max(result.height, 1);
            ctx.fillStyle = "#000000";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.fillStyle = "#FFFFFF";
        }
        else {
            if (canvas.width == result.width && canvas.height == result.height) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
            }
            else {
                canvas.width = Math.max(result.width, 1);
                canvas.height = Math.max(result.height, 1);
            }

            ctx.fillStyle = TextUtils.integerToColor(fontColor);
        }
    }

    var lineHeight = fontSize;
    if (maxWidth == 0) {
        maxWidth = undefined;
        singleLine = true;
    }

    var ctxFont = fontSize + "px Arial";
    ctx.font = ctxFont;

    if (singleLine && !dotsAtEnd) {
        var result = measureLine(ctx, text, maxWidth, lineHeight);
        resizeCanvasToResult(result);
        ctx.font = ctxFont;
        ctx.fillText(text, 0, lineHeight); // since textBaseline = "top" doesn't work - compensate for it
    }
    else {
        var result = wrapText(ctx, text, 0, 0, maxWidth, lineHeight * 1.15, dotsAtEnd);
        resizeCanvasToResult(result);
        ctx.font = ctxFont;
        drawLines(ctx, result);
    }

    var width = canvas.width;
    var height = canvas.height;
    var byteArray = ctx.getImageData(0, 0, width, height).data;
    var size = byteArray.length;

    var buffer = _malloc(size);
    HEAPU8.set(byteArray, buffer);
    if (callback) {
        dynCall('viiiiii', callback, [arg, width, height, grayscale, buffer, size]);
    }
}

TextUtils.integerToColor = function(c) {
    function componentToHex(c) {
        var hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
    }

    function rgbToHex(r, g, b) {
        return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
    }

    var r = (c >> 8 * 0) & 0xFF;
    var g = (c >> 8 * 1) & 0xFF;
    var b = (c >> 8 * 2) & 0xFF;

    return rgbToHex(r, g, b);
}



//////////////////
// WEBPACK FOOTER
// /src/claw/sdk/src/claw/graphics/emscripten/Application.textutils.js
// module id = 18
// module chunks = 0